import React from 'react';
import './Footer.css';
import { motion } from 'framer-motion';

import { FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaEnvelope } from 'react-icons/fa';
import analysisImage from '../Images/analysis.png';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
    }
};


const Footer = () => {

    const navigate = useNavigate();

    const handleScrollToSection = (sectionId) => {
        navigate('/', { state: { scrollTo: sectionId } });
    };


    return (
        <footer className="footer">
            {/* CTA Banner */}
            <div className="footer-cta">
                <div className="footer-cta-left">
                    <h2>Get started with SkillsHap today</h2>
                    <p>Try SkillsHap free for 7 days you’ll have access to every feature. Cancel at any time.</p>
                    <div className="footer-buttons">
                        <Link to="/BookDemoForm">
                            <button className="btn-white">Book a Demo</button> </Link>
                        <Link to="/SignupForm">
                            <button className="btn-outline">SIGN UP FOR FREE</button>
                        </Link>
                    </div>
                </div>
                <div className="footer-cta-right">
                    <img src={analysisImage} alt="Footer Visual" />
                </div>
            </div>

            {/* Footer Main Section */}
            <div className="footer-main">

                <div className="footer-column logo-column">
                    <motion.div
                        className="footer-branding"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: 'easeOut' }}
                    >
                        <motion.span
                            className="footer-brand-name"
                            whileHover={{ scale: 1.05, color: "yellow" }}
                            transition={{ duration: 0.3 }}
                        >
                            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;  SkillsHap
                        </motion.span>

                        <motion.p
                            className="footer-tagline"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5, duration: 1 }}
                        >
                            Achieve Your Dream Job 5X Faster with SkillsHap
                        </motion.p>

                        <motion.div
                            className="footer-social"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 1, duration: 1 }}
                        >
                            <motion.div whileHover={{ scale: 1.3 }} transition={{ type: 'spring', stiffness: 300 }}>
                                <a href="https://www.instagram.com/skillshap__/" target="_blank" rel="noopener noreferrer">
                                    <FaInstagram />
                                </a>
                            </motion.div>

                            <motion.div whileHover={{ scale: 1.3 }} transition={{ type: 'spring', stiffness: 300 }}>
                                <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                                    <FaFacebook />
                                </a>
                            </motion.div>

                            <motion.div whileHover={{ scale: 1.3 }} transition={{ type: 'spring', stiffness: 300 }}>
                                <a href="https://www.linkedin.com/company/skillshap/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                                    <FaLinkedin />
                                </a>
                            </motion.div>

                            <motion.div whileHover={{ scale: 1.3 }} transition={{ type: 'spring', stiffness: 300 }}>
                                <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
                                    <FaYoutube />
                                </a>
                            </motion.div>

                            <motion.div whileHover={{ scale: 1.3 }} transition={{ type: 'spring', stiffness: 300 }}>
                                <a href="mailto:hr@skillshap.com">
                                    <FaEnvelope />
                                </a>
                            </motion.div>

                        </motion.div>
                    </motion.div>
                </div>
                <div className="footer-column">
                    <h4>Quick Links</h4>
                    <ul>
                        <li>Products</li>
                        {/* <li>Programs</li> */}
                        <li>
                            <Link to="/ContactSkill" className="footer-link">
                                Contact Us
                            </Link>
                        </li>
                        <li>
                            <Link to="/TermsAndConditions" className="footer-link">
                                Terms & Conditions
                            </Link>
                        </li>
                        <li>
                            <Link to="/PrivacyPolicy" className="footer-link">
                                Privacy & Policy
                            </Link>
                            </li>
                        <li>
                            <Link to="/AboutUS" className="footer-link">
                                About US
                            </Link>
                        </li>
                    </ul>
                </div>


                <div className="footer-column" onClick={() => handleScrollToSection('skill-assignment')}>
                    <h4>Solutions</h4>
                    <ul>
                        <li>AI Skills Assessment</li>
                        <li>Student Portal</li>
                        <li>AI Resume Builder</li>
                        <li>AI Mock Interview</li>
                        <li>Mentorship</li>
                        <li>Personal Branding</li>
                        <li>Company Portal</li>
                        <li>ATS Recommendation</li>
                    </ul>
                </div>

                <div className="footer-column">
                    <h4>Office Address</h4>
                    <p>Novel MSR Park<br />
                        Corporate Office:<br />
                        Novel Office, <br />
                        Marathahalli - 560037,Bengaluru, India <br />
                    </p>
                </div>
                <div className="footer-column">
                    {/* <h4>Customer Service</h4> */}
                    <ul>
                        {/* <li>FAQs</li> */}
                        {/* <li>Contact Us</li> */}
                        {/* <li>Shipping & Delivery Info</li> */}

                    </ul>
                </div>
            </div>

            {/* Bottom */}
            <div className="footer-bottom">
                <p>Copyright © 2024-2026 SkillsHap Pvt Ltd</p>
            </div>
        </footer>
    );
};

export default Footer;